import { create } from "zustand";

interface ApiKeyState {
  localApiKey: string;
  originalApiKey: string;
  hasChanges: boolean;
  setLocalApiKey: (key: string) => void;
  setOriginalApiKey: (key: string) => void;
  resetChanges: () => void;
}

const ApiKeyStore = create<ApiKeyState>((set, get) => ({
  localApiKey: "",
  originalApiKey: "",
  hasChanges: false,
  
  setLocalApiKey: (key: string) => {
    const { originalApiKey } = get();
    set({ 
      localApiKey: key,
      hasChanges: key !== originalApiKey
    });
  },
  
  setOriginalApiKey: (key: string) => {
    set({ 
      originalApiKey: key,
      localApiKey: key,
      hasChanges: false 
    });
  },
  
  resetChanges: () => {
    const { originalApiKey } = get();
    set({ 
      localApiKey: originalApiKey,
      hasChanges: false 
    });
  }
}));

export default ApiKeyStore;
